import { Link, NavLink } from "react-router-dom";

const navLinkClass = ({ isActive }) =>
  `text-[18px] transition-colors ${isActive ? "text-zinc-900" : "text-zinc-500 hover:text-zinc-900"}`;

const PublicNav = () => {
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-zinc-200/70">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-3">
          <span className="font-logo text-[25px] text-[#303030]">Club Pass</span>
          <span className="text-[15px] text-zinc-400 hidden sm:inline">by Airsoft Systems</span>
        </Link>
        <nav className="flex items-center gap-5 sm:gap-8">
          <NavLink to="/pricing" className={navLinkClass}>
            Pricing
          </NavLink>
          <NavLink to="/login" className={navLinkClass}>
            Sign in
          </NavLink>
          <Link
            to="/login"
            className="hidden sm:inline-flex items-center h-10 px-[15px] text-[15px] font-medium rounded-md bg-[#303030] hover:bg-[#1A1A1A] text-white transition-colors"
          >
            Get started
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicNav;
